import _, { lte } from 'lodash';
import React, { Component, useState, useEffect, useContext, useRef, Fragment } from 'react';
import { Util } from './Util';
import Icon from './Icon';
import PropTypes from 'prop-types';
import { ScrollView, Text, TouchableOpacity, View } from 'react-native';
import styled from 'styled-components/native'
import { BasicText } from '../Styles';

let __temp_last_click = null;

const TableRow = styled.View`
    display: flex;
    flex-direction: row;
    padding-top: 3px;
    padding-bottom: 3px;
    align-items: center;
    height: ${props => props.rowHeight != undefined? props.rowHeight + "px" : "auto"};
`;

const TableRowA = styled(TableRow)`
    background-color: #f9f9f9;
    padding-top: 5px;
    padding-bottom: 5px;
`;

const TableRowB = styled(TableRow)`
    background-color: #ffffff;
    padding-top: 5px;
    padding-bottom: 5px;
`;

const TableHead = styled.View`
    display: flex;
    flex-direction: column;
`;

const TableBody = styled.View`
`;

// mobile align-items: center;
// desktop justify-content: space-evenly;
const Table = styled.View`
    flex-direction: column;
    justify-content: center;
`;

export const Pagination = styled.View`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
`;

const PageNumber = styled.Text`
    padding: 12px;
    text-align: center;
`;

const TableText = styled(BasicText)`
    font-size: ${props => props.theme.screen == 'mobile' ? props.theme.sm : props.theme.reg};
`;

const ActivePageNumber = styled(PageNumber)`
    border-radius: 4px;
    background-color: #00bacd;
    color: #ffffff;
`;

function TableCell(props) {
    return <View style={{...{ width: props.width || "25%", paddingLeft: 5, paddingRight: 5}, ...props.style}}><TableText style={{...props.style, display: 'flex', alignItems: 'center'}}>{props.children}</TableText></View>;
}

function TableHeading(props) {
    return <View style={{ width: props.width || "25%", paddingLeft: 5, paddingRight: 5}}><TableText style={{ fontWeight: "bold" }}>{props.children}</TableText></View>
}

export function Selection(props) {
    const [isChecked, setIsChecked] = useState(props.selection.indexOf(props.item) >= 0);

    useEffect(() => {
        const checkedNow = props.selection.indexOf(props.item) >= 0;
        if (checkedNow != isChecked) {
            setIsChecked(checkedNow);
        }
    }, [props.selection]);

    const clicky = (e) => {
        e.stopPropagation();

        const checked = e.currentTarget.checked;
        const newSelection = props.selection.slice();


        const idx = newSelection.indexOf(props.item);
        if (checked == false && idx >= 0) {
            newSelection.splice(idx, 1);
        } else if (checked == true && idx == -1) {
            if (e.shiftKey) {
                let first = _.indexOf(props.data, __temp_last_click);
                let last = _.indexOf(props.data, props.item);
                if (first > last) {
                    const lastLast = last;
                    last = first;
                    first = lastLast;
                }
                for (let x = first; x <= last; x++) {
                    if (newSelection.indexOf(props.data[x]) == -1) {
                        newSelection.push(props.data[x]);
                    }
                }
            } else {
                newSelection.push(props.item);
            }

            __temp_last_click = props.item;
        }

        props.setter(newSelection);
    };

    const stuff = {};
    if (isChecked) {
        stuff.checked = true;
    }

    const TagName = props.tagName || "input";

    return <TagName type="checkbox" onClick={clicky} {...stuff} />;
}
export function xTabular(props) {
    return <View><Text>Todo</Text></View>;
}

export class Tabular extends Component {
    constructor(props) {
        super(props);
        this.state = { selected: [], sortedData: null, loaded: props.loaded };
        if (props.defaultSort != undefined) {
            if (typeof props.defaultSort == "function") {
                this.state.sort_by = props.defaultSort;
            } else {
                this.state.sort_by = (r) => r[props.defaultSort];
            }
        }

        if (props.defaultSortOrder)
            this.state.currentSortOrder = props.defaultSortOrder;
    }

    onClick(e, r) {
        //return false from the onclick to prevent our select logic from running.
        if (this.props.onClick) {
            if (this.props.onClick(r, e) == false) {
                return;
            }
        }

        var s = this.state.selected.slice();
        if (_.includes(s, r)) {
            _.remove(s, r);
        } else {
            s.push(r);
        }
        const callback = this.props.onSelect ? () => this.props.onSelect(s) : null;
        this.setState({ selected: s }, callback)
    }

    static getDerivedStateFromProps(nextProps, nextState) {
        var currentlySelected = _.map(nextState.selected, nextProps.selectKey);

        if (true && nextProps.data != undefined) {
            var ret = { selected: nextProps.data.filter(a => currentlySelected.indexOf(a[nextProps.selectKey]) >= 0) };

            /* if (nextState.sortedData == null || nextState.sortedData.length != nextProps.data.length || nextProps.ticky) {
                ret.sortedData = nextProps.data;
            } else if (_.difference(nextState.sortedData, nextProps.data).length > 0) {
                //this should stop ticky from being used, but might be slow?
                ret.sortedData = nextProps.data;
            } */

            ret.sortedData = nextProps.data

            return ret;

            // return {selected: nextProps.data.filter(a=>currentlySelected.indexOf(a[nextProps.selectKey])>=0)};
        }

        return null;
    }

    componentDidMount() {
        this.updateSortedData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.filter != undefined && this.props.filter != prevProps.filter || this.props.loadedCount != prevProps.loadedCount) {
            this.updateSortedData();
        }
    }

    clickHeading(column, currentSort) {

        var sortOrder = "asc";
        if (this.state.currentSort == column.props.title) {
            sortOrder = this.state.currentSortOrder == "asc" ? "desc" : "asc";
        }
        this.setState({ sort_by_column: column.props, sort_by: column.props.data, currentSort: column.props.title, currentSortOrder: sortOrder },

            () => {
                this.updateSortedData();
            });
    }

    updateSortedData() {
        if (this.props.onSort) {
            const ret = this.props.onSort(this.state.sort_by_column, this.state.currentSortOrder);
            if (ret == false) {
                return;
            }
        }
        var sortedData = this.props.data || [];
        if (this.state.sort_by) {



            sortedData = _.sortBy(this.props.data, r => {
                try {
                    var el = this.state.sort_by(r);

                    return this.textOf(el, this.state.sort_by_column);
                } catch (exception) {
                    console.log("exception occured in tabular's sort... ", exception);
                    return "";
                }
            });
            if (this.state.currentSortOrder == "desc") {
                sortedData = _.reverse(sortedData);
            }
        }

        this.setState({ sortedData: sortedData });
    }

    textOf(el, colDef) {
        var ourValue = el;

        if (el && typeof el.type == "function") {
            try {
                el = el.type(el.props)
            } catch (ex) {

            }
        }

        if (el && (typeof el == "object" && el.props)) {
            if (typeof el.props.children == "object") {
                ourValue = _.join(_.map(el.props.children, a => this.textOf(a)), ' ');
            } else {
                ourValue = el.props.children;
            }
        }

        if (colDef && colDef.className && colDef.className.indexOf("numeric") >= 0) {
            if (ourValue.replace) {
                ourValue = ourValue.replace(",", "");
            }
            ourValue = parseFloat(ourValue);
        }

        return ourValue;
    }

    setPage(p) {
        const pages = _.chunk(this.state.sortedData, this.props.pageSize);
        if (p < 0) {
            p = 0;
        }
        if (p > pages.length - 1) {
            p = pages.length - 1;
        }
        this.setState({ page: p });

        return false;
    }

    render() {
        const childrenColumnWidths = [];
        const children = _.filter(this.props.children, (child)=>child != null);
        var columnDefinitions = _.compact(React.Children.map(children, (c) => {
            if (c != null && c.props) {
                if(c.props.width != undefined){
                    childrenColumnWidths.push(c.props.width);
                }
                return c;
            } else {
                return null;
            }
        }));
        var rows = [];
        var count = 0;

        //columnDefinitions = _.flatten(_.filter(columnDefinitions, (datum) => {return datum != null}));
        //this.props.rowGroupings = {column.theId + "" + rowVal: # of occurrences, ...}
        const defaultColumnWidth = (100 / children.length) + "%";

        let columnWidths = [];
        if(this.props.widths != undefined){
            columnWidths =  this.props.widths;
        } else if(childrenColumnWidths.length > 0){
            columnWidths = childrenColumnWidths;
        } else {
            columnWidths = _.range(0, columnDefinitions.length).map((i) => defaultColumnWidth);
        }

        var headings = _.map(columnDefinitions, (c, colNumber) => {
            let decoration = null;
            if (this.state.currentSort == c.props.title && c.props.title != undefined && c.props.title.length > 0) {
                decoration = <Icon icon={this.state.currentSortOrder == "asc" ? "arrow-alt-down" : "arrow-alt-up"} />
            }

            const HeadingComponent = c.props.headingComponent || Fragment;
            const headingProps = c.props.headingComponent ? { ...c.props } : {};

            return (
                <TableHeading
                    key={"heading" + colNumber}
                    width={columnWidths[colNumber]}
                    onClick={() => this.clickHeading(c)}
                    className={
                        (c.props.className || "") +
                        " " +
                        (this.state.currentSort == c.props.title && c.props.title != undefined && c.props.title.length > 0
                            ? "sorted-" + this.state.currentSortOrder
                            : "")
                    }
                    style={c.props.style}
                >
                    <HeadingComponent {...headingProps}>{c.props.title}</HeadingComponent> {decoration}
                </TableHeading>
            );
        });
        var that = this;
        var seenGroups = {};

        let visibleData = this.state.sortedData;
        
        let pageChunks = [];
        let currentPageIdx = 0;
        if (this.props.pageSize) {
            currentPageIdx = this.state.page || 0;
            pageChunks = _.chunk(visibleData, this.props.pageSize);
            visibleData = pageChunks[currentPageIdx];
        }

        var rows = _.map(visibleData, (row, idx) => {
            if (this.props.dataFucker) {
                row = this.props.dataFucker(row);
            }
            var cells = [];
            _.forEach(columnDefinitions, (c, colNumber) => {
                var tdValue = null;

                if (c.props.children) {
                    if (Array.isArray(c.props.children)) {
                        tdValue = c.props.children.map((child) => {
                            var props = {}
                            props.scope = { ...child.props.scope };
                            props.scope.row = { ...row };
                            props.key = "clone" + count++;
                            return React.cloneElement(child, props);
                        });
                    } else {
                        var props = {};
                        props.scope = { ...c.props.children.props.scope };
                        props.scope.row = { ...row };
                        props.key = "clone" + count++;
                        tdValue = React.cloneElement(c.props.children, props);
                    }

                } else {
                    try {
                        tdValue = c.props.data(row, idx);
                    } catch (e) {
                        debugger;
                        tdValue = "?";
                    }

                }

                if (typeof tdValue == "object" && (!Array.isArray(tdValue)) && tdValue != null && (!React.isValidElement(tdValue))) {
                    tdValue = "..."; //JSON.stringify(tdValue).substring(0,10) + "...";
                }

                const keyLookup = c.props.title + "" + tdValue;

                if (tdValue != undefined && typeof tdValue == "string" && tdValue.trim().length > 0 && c.props.fieldType == "colour") {
                    tdValue = <span style={{ backgroundColor: tdValue, paddingLeft: "10px", marginLeft: "5px" }}>&nbsp;</span>;
                }

                if (this.props.rowGroupings != undefined && this.props.rowGroupings[keyLookup] != undefined) {
                    if (("" + tdValue).trim().length > 0 && seenGroups[keyLookup] == undefined) {
                        //we haven't seen this value in this column yet so make a group of it
                        cells.push(<TableCell width={columnWidths[colNumber]} rowSpan={this.props.rowGroupings[keyLookup]} className={"tabular-td " + (c.props.className || "")} style={c.props.style} key={"cell" + count++}>{tdValue}</TableCell>)
                        seenGroups[keyLookup] = "seen";
                    }
                } else {
                    cells.push(<TableCell width={columnWidths[colNumber]} className={"tabular-td " + (c.props.className || "")} style={c.props.style} key={"cell" + count++}>{tdValue}</TableCell>);
                }
            });

            const hash = this.props.hashWithPosition ? Util.hash(row) + "-" + idx : Util.hash(row);


            if (this.props.showRaw) {
                cells.push(<TableCell key="raw"><Icon icon="file-code" onClick={() => console.log("Row source", JSON.stringify(row))} /></TableCell>);
            }

            let trClassName = "tabular-row";
            if (_.includes(that.state.selected, row)) {
                trClassName += " selected";
            }
            if (this.props.onClick != undefined) {
                trClassName += " clickable";
            }

            //return <TableRow key={"row" + hash} className={trClassName} onClick={(e)=>that.onClick(e, row)}>{cells}</TableRow>
            const TheRowComp = idx % 2 == 1 ? TableRowA : TableRowB;
            return <TheRowComp key={"row" + hash} className={trClassName} onClick={(e) => that.onClick(e, row)}  rowHeight={this.props.rowHeight}>{cells}</TheRowComp>
        });

        let Container = View;
        let containerProps = {style: {flexGrow: 1, justifyContent: "space-between"}};

        if(this.props.scrollable){
            // @ts-ignore
            Container = ScrollView;
            containerProps = {
                horizontal: true,
                contentContainerStyle: { flexGrow: 1, flexDirection: "column" }
            };
        }

        return <Container {...containerProps}>
            <Table style={this.props.style} className={"tabular " + this.props.className}>
                <TableHead>
                    {this.props.extraHeadingRow ? this.props.extraHeadingRow : null}
                    <TableRow>{headings}</TableRow>
                </TableHead>
                <TableBody>
                    {rows}
                </TableBody>
            </Table>
            {pageChunks.length > 0 ? <Paginator currentPageIdx={currentPageIdx} setPage={(page)=>this.setPage(page)}>{pageChunks}</Paginator> : null}
        </Container>
    }
}

export const Paginator = ({ children = [], currentPageIdx = 0, setPage = (page)=>{ console.log("no setter"); }, numberShown = 10 }) => {
    const pages = useRef([]);
    const [displayedPages, setDisplayedPages] = useState([]);

    useEffect(()=>{
        pages.current = children.map((c, i) => {
            if (currentPageIdx == i) {
                return <TouchableOpacity key={"touchable-" + i} onPress={() => setPage(i)}><ActivePageNumber key={i}>{i + 1}</ActivePageNumber></TouchableOpacity>;
            } else {
                return <TouchableOpacity key={"touchable-" + i} onPress={() => setPage(i)}><PageNumber key={i}>{i + 1}</PageNumber></TouchableOpacity>;
            }
        });

        updateDisplayedPages();
    }, [children]);

    useEffect(()=>{
        updateDisplayedPages();
    }, [currentPageIdx]);

    const updateDisplayedPages = () =>{
        const newDisplayed = [];

        if(pages.current.length < numberShown){
            _.forEach(pages.current, (p)=>{
                newDisplayed.push(p);
            });
        } else {
            //20 w/ current @ 0 => 0,1,2,3,4,5,6,7,8,9 
            //20 w/ current @ 11 => 6,7,8,9,10, 11 ,12,13,14,15
            const splitAt = Math.ceil(numberShown / 2);
            _.forEach(pages.current, (p, idx)=>{
                if( (currentPageIdx + splitAt <= numberShown && idx < numberShown) ||
                (idx >= currentPageIdx - splitAt && idx < currentPageIdx + splitAt) ||
                (currentPageIdx + splitAt >= pages.current.length && idx >= pages.current.length - numberShown) ){
                    newDisplayed.push(p);
                }
            });
        }

        newDisplayed.unshift(<TouchableOpacity key="prev" onPress={() => setPage(currentPageIdx - 1)}><Icon icon={["fal", "chevron-left"]} /></TouchableOpacity>);
        newDisplayed.push(<TouchableOpacity key="next" onPress={() => setPage(currentPageIdx + 1)}><Icon icon={["fal", "chevron-right"]} /></TouchableOpacity>);

        setDisplayedPages(newDisplayed);
    }

    return <Pagination>{displayedPages}</Pagination>;
}

export class TabularColumn extends Component {
    render() {
        return <TableCell></TableCell>
    }
}

export function TabularDataSet(props) {
    const [loadedCount, setLoadedCount] = useState(-1);
    const [myData, setMyData] = useState([]);
    let myProps = { ...props };

    const refresh = (data) => {
        if (props.dataSet && props.dataSet.loadedCount > loadedCount) {
            setMyData(props.dataSet.filter(props.filter));
            setLoadedCount(props.dataSet.loadedCount);
        }
    }

    useEffect(() => {
        if (props.dataSet) {
            props.dataSet.callback(refresh);
            if (loadedCount == -1) {
                refresh();
            }
        }
    }, [props.dataSet]);

    myProps.data = myData;
    myProps.loadedCount = loadedCount;
    myProps.onSort = (col, order) => {
        const a = myData;

        if (col && col.sortCol) {
            props.dataSet.sort(col.sortCol, order)
            return false;
        }

        return true;
    };
    if (myProps.data.length > 0) {
        return <Tabular {...myProps} />;
    }

    if (myProps.data.length == 0 && myProps.loadedCount > 0) {
        return <div className="loading">{props.noData || "No Data!"}</div>;
    }

    return <div className="loading">Please Wait</div>;
}

Tabular.propTypes = {
    rowHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    data: PropTypes.array,
    pageSize: PropTypes.number,
    scrollable: PropTypes.bool
}

Tabular.defaultProps = {
    scrollable: false
}

TabularDataSet.propTypes = {
    defaultSort: PropTypes.oneOf([PropTypes.string, PropTypes.func, null]),
    defaultSortOrder: PropTypes.string,
    dataSet: PropTypes.object,
    filter: PropTypes.func,
    noData: PropTypes.string
}

TabularColumn.propTypes = {
    title: PropTypes.string,
    data: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}